import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, Validators } from '@angular/forms';
import { VALIDATION_MESSAGE_RESOLVER_LIST } from './provider';

const VALIDATION_ERROR_CODE_PRIORITY = [Validators.required.name, Validators.min.name, Validators.max.name];

@Injectable()
export class ValidationMessageResolverService {
  private readonly resolvers = inject(VALIDATION_MESSAGE_RESOLVER_LIST);
  private readonly translateService = inject(TranslateService);

  getErrorMessage(formControl: FormControl): string | null {
    if (formControl.valid) { return null; }

    const priorityErrorCode = VALIDATION_ERROR_CODE_PRIORITY.find(errorCode => formControl.hasError(errorCode));
    if (priorityErrorCode) {
      return this.getErrorMessageByCode(formControl, priorityErrorCode);
    }

    const errorCode = Object.keys(formControl.errors)?.[0];
    return this.getErrorMessageByCode(formControl, errorCode);
  }

  getErrorMessageByCode(formControl: FormControl, errorCode: string): string {
    const resolver = this.resolvers.find(t => t.errorCode === errorCode);
    return resolver?.getMessage(formControl.getError(errorCode)) ?? this.defaultValidationMessage();
  }

  private defaultValidationMessage(): string {
    return this.translateService.instant('label.validation.default');
  }
}
